
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4556_18675)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#C7CBCF"}},[_c('path',{attrs:{"d":"M4.83 1.03L1.993 3.067c-.446.32-.549.5-.549.925v3.269c0 .283.241.377.413.254l3.29-2.365c.188-.136.23-.248.23-.522V1.36c0-.36-.309-.502-.549-.33zM11.46 9.386h.868c.263 0 .475.212.475.476v.869a.474.474 0 01-.475.475h-.868a.475.475 0 01-.476-.475v-.869c0-.264.212-.476.476-.476zm-2.736 0h.868c.263 0 .475.212.475.476v.869a.474.474 0 01-.475.475h-.868a.475.475 0 01-.476-.475v-.869c0-.264.212-.476.476-.476zm2.736-2.863h.868c.263 0 .475.212.475.476v.869a.474.474 0 01-.475.475h-.868a.475.475 0 01-.476-.475v-.869c0-.263.212-.476.476-.476zm-2.736 0h.868c.263 0 .475.212.475.476v.869a.474.474 0 01-.475.475h-.868a.475.475 0 01-.476-.475v-.869c0-.263.212-.476.476-.476zm-1.857-3.55v11.58c0 .218 0 .491.385.491H9.67V13.64c0-.474.382-.855.856-.855.475 0 .856.381.856.855v1.404H13.8c.383 0 .384-.273.384-.492V5.56c0-.267-.232-.487-.482-.581L7.35 2.589c-.245-.09-.483.05-.483.384zM3.034 11.828h.756c.178 0 .32.15.32.336v.726a.327.327 0 01-.32.335h-.756a.328.328 0 01-.32-.335v-.726c0-.186.142-.336.32-.336zm0-2.117h.756c.178 0 .32.149.32.335v.726a.328.328 0 01-.32.336h-.756a.328.328 0 01-.32-.336v-.726c0-.186.142-.335.32-.335zm2.504-3.656a.456.456 0 00-.251.089L1.538 8.839c-.59.424-.725.66-.725 1.223v4.35c0 .404-.018.631.384.631h4.43c.403 0 .386-.227.386-.63V6.58c0-.313-.225-.534-.475-.526z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4556_18675"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h15v15H0z"}})])])])
          )
        }
      }
    